PM_SCREEN_TYPE_YOGA_HOME